import { useTranslation } from "react-i18next";
import type { SchemaRegion } from "../../../../api/restaurantSchema";

/** Картата вдясно, когато нищо не е избрано: регионът, маси и места. */
const RegionSummary = ({ region }: { region: SchemaRegion }) => {
  const { t } = useTranslation();
  const tables = region.elements.filter((element) => element.kind === "table");
  const seatCount = tables.reduce((sum, table) => sum + (table.seats ?? 0), 0);
  const stats = [
    { key: "tables", value: tables.length },
    { key: "seats", value: seatCount },
  ];
  return (
    <section className="flex flex-none flex-col gap-3.5 rounded-[14px] border border-shade-2 bg-surface p-4">
      <div className="truncate text-[15px] font-bold leading-[1.25] text-ink">{region.name}</div>
      <div className="grid grid-cols-2 gap-2">
        {stats.map(({ key, value }) => (
          <div key={key} className="flex flex-col gap-0.5 rounded-[10px] bg-schema-canvas px-3 py-2.5">
            <span className="text-[11.5px] font-semibold text-muted">
              {t(`restaurantSchema.summary.${key}`)}
            </span>
            <span className="text-[24px] font-bold leading-[1.2] tabular-nums text-ink">
              {value}
            </span>
          </div>
        ))}
      </div>
      <div className="text-[12.5px] leading-[1.45] text-body">
        {t("restaurantSchema.summary.hint")}
      </div>
    </section>
  );
};

export default RegionSummary;
